import { IWfCollabOp, wfLwwKeyOf } from "@kuika/kuika-cl-model";

/**
 * Batch-level merge before send: CONSECUTIVE runs on one LWW key collapse to the last
 * write (drag streams → one wfGeometrySet with the final groups merged; typing streams →
 * one wfPropSet / wfDocPropSet). Only adjacent output entries merge, so an op can never
 * jump across a structural op — or any other op — that targets the same element.
 */
export function coalesceWfOps(ops: IWfCollabOp[]): IWfCollabOp[] {
  const result: IWfCollabOp[] = [];
  for (const op of ops) {
    const previous: IWfCollabOp | undefined = result[result.length - 1];
    if (previous !== undefined && canMergeAdjacent(previous, op)) {
      if (op.kind === "wfGeometrySet") {
        const merged: IWfCollabOp = { ...previous };
        if (op.bounds !== undefined) merged.bounds = op.bounds;
        if (op.waypoints !== undefined) merged.waypoints = op.waypoints;
        if (op.labelBounds !== undefined) merged.labelBounds = op.labelBounds;
        merged.opId = op.opId;
        result[result.length - 1] = merged;
      } else {
        result[result.length - 1] = op;
      }
      continue;
    }
    result.push(op);
  }
  return result;
}

function canMergeAdjacent(previous: IWfCollabOp, next: IWfCollabOp): boolean {
  if (previous.kind !== next.kind) return false;
  if (next.kind !== "wfGeometrySet" && next.kind !== "wfPropSet" && next.kind !== "wfDocPropSet") return false;
  const previousKey: string | null = wfLwwKeyOf(previous);
  const nextKey: string | null = wfLwwKeyOf(next);
  return previousKey !== null && previousKey === nextKey;
}
